import { Injectable } from '@angular/core';
import { SnackbarDataInterface } from './snackbar-data-interface';
import { SnackBarMessageComponent } from './snack-bar-message.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
    providedIn: 'root'
})
export class Snackbar {
    private static readonly duration = 5000;
    private config: {duration:number, data: SnackbarDataInterface | null} = { duration: Snackbar.duration, data: null };

    constructor(
        private toaster: MatSnackBar
    ) {
    }

    public show(data: SnackbarDataInterface): any {
        const config = {...this.config};

        if (!config.data) {
            config.data = data;
        }
        return this.toaster.openFromComponent(SnackBarMessageComponent, config);
    }
}
